import { AppMyBusinessShopItem } from '../AppMyBusinessShopItem';
import { StyledContainer, StyledItemsGrid } from './AppMyBusinessShop.styled';

const AppMyBusinessShop = () => {
	return (
		<StyledContainer>
			<StyledItemsGrid>
				{new Array(10).fill(0).map((_, index) => (
					<AppMyBusinessShopItem key={index} />
				))}
			</StyledItemsGrid>
		</StyledContainer>
	);
};

export { AppMyBusinessShop };
